import request from '@/axios/request.js'

// 创建账号
export function registerID(data) {
  // {
  //     "account": "", 手机号码
  //      "companyName":"", 公司名称
  //     "captcha": "", 验证码
  //     "inviteCode": "", 邀请码
  //     "password": "", 密码
  //     "spread": "" 分销绑定关系的ID
  // }
  return request({
    url: '/auth/oauth/register',
    method: 'post',
    data
  })
}
export function getVerify(data) {
  // {
  //     "phone": "", 手机号码
  //     "type": "" 短信类型 bind绑定手机短信 login登陆短信 register注册短信
  // }
  return request({
    url: '/auth/oauth/register/verify',
    method: 'post',
    data
  })
}
export function codeverify(data) {
  // {
  //   "phone": "13539929029", 手机号码
  //   "type": "register", 短信类型 bind绑定手机短信 login登陆短信 register注册短信
  //   "captcha":"9946"   验证码
  // }
  return request({
    url: '/auth/oauth/register/codeverify',
    method: 'post',
    data
  })
}

export function verifyphone(params) {
  // {
  //     "phone": "", 手机号码
  // }
  return request({
    url: '/auth/oauth/register/verifyphone',
    method: 'get',
    params
  })
}
export function chpasswd(data) {
  /* {
          "phone": "13539929025",
    "captcha": "7287",
    "password": "jWJvCFtFEUU=",
    "newPassword": "3Qt1NrmHau0=",
    "confirmPassword":"3Qt1NrmHau0=",
    "tag":2   --1正常修改密码(不需获取验证码，通过原密码修改)，2忘记密码修改密码(需获取验证码)
     }
     */
  return request({
    url: '/auth/oauth/passwd/chpasswd',
    method: 'post',
    data
  })
}

// H5登录授权
export function loginWeb(data) {
  // {
  //     "password": "",必填
  //     "spread": "",
  //     "username": ""
  // }
  return request({
    url: '/auth/oauth/login',
    method: 'post',
    data
  })
}

// 退出登录
export function logoutWeb() {
  return request({
    url: '/auth/oauth/auth/logout',
    method: 'post'
  })
}

// 获取用户信息
export function getUserInfo() {
  return request({
    url: '/yshop-mall/userinfo',
    method: 'get'
  })
}

// 修改用户信息
/**
    avatar: this.formData.avatar,
    nickname: this.formData.nickname
*/
export function editUserInfo(data) {
  return request({
    url: '/yshop-mall/user/edit',
    method: 'post',
    data
  })
}

export function getCodeImg() {
  return request({
    url: '/code',
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/login.js